// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"0e9a15f9","453":"34521bd5"}[chunkId] + ".chunk.js";
};